<template>
  <div class="home">
    <div class="container">
      <p class="title">网上预约</p>
      <div class="radio-tab">
        <el-radio-group v-model="tabPosition" @input="inputRadio">
          <el-radio-button label="inquire">预约查询</el-radio-button>
        </el-radio-group>
      </div>
      <el-card shadow="never" v-if="selectedStepType !== 'inquire'">
        <div class="step-progress">
          <div v-for="(step, index) in steps" :key="index" :class="{ active: currentIndex === index }" class="step">
            <span class="step-number"><span>{{ index + 1 }}</span></span>
            <span class="step-text">{{ step.text }}</span>
          </div>
        </div>
      </el-card>
      <div class="stepsContent">
        <component :is="selectedStepType"></component>
      </div>
<!--      <div class="btn" v-if="result">-->
<!--        <el-button v-if="currentIndex !== 0" class="btn-right" type="primary" @click="back">上一步-->
<!--        </el-button>-->
<!--        <el-button v-if="currentIndex < steps.length-1" class="btn-right" type="primary" @click="next">下一步-->
<!--        </el-button>-->
<!--        <el-button v-if="currentIndex === steps.length-1 && !isAmend" plain type="primary" @click="submit">提交-->
<!--        </el-button>-->
<!--        <el-button v-if="currentIndex === steps.length-1 && isAmend" plain type="primary" @click="amend">改约-->
<!--        </el-button>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import stepOne from "../components/stepOne.vue"
import stepTwo from "../components/stepTwo.vue"
import stepThree from "../components/stepThree.vue"
import stepFour from "../components/stepFour.vue"
import resultView from "../components/result.vue"
import inquire from "../components/inquirebak.vue"
import {submitRPriorBusi} from "@/api/project"
import {amendOrder} from "@/api/busi"
import wasm from "@/mixins/wasm"
import user from "@/mixins/user"
export default {
  name: 'HomeView',
  components: {
    stepOne, stepTwo, stepThree, stepFour, resultView, inquire
  },
  mixins: [wasm,user],
  watch: {
    currentIndex(val, old) {
      if (val === 0) {
        this.$store.commit("resetDept")
        this.$store.commit("reSetProject")
        this.$store.commit("reSetRule")
      }
      if (val === 1) {
        this.$store.commit("reSetProject")
        this.$store.commit("reSetRule")
        if (this.$store.state.dept.deptId === undefined) {
          this.$message.warning("请先选择部门")
          this.currentIndex = 0
          this.currentComponent()
        }
      }
      if (val === 2) {
        this.$store.commit("reSetRule")
        if (this.$store.state.project.projectId === undefined) {
          this.$message.warning("请先选择事项")
          this.currentIndex = 1
          this.currentComponent()
        }
      }
      if (val === 3) {
        if (this.$store.state.rule.ruleId === undefined) {
          this.$message.warning("请先选择时间")
          this.currentIndex = 2
          this.currentComponent()
        }
      }
    }
  },
  async mounted() {
    await this.initwasm().then(() => {
      this.login()
    })
  },
  data() {
    return {
      tabPosition: 'inquire',
      isAgain: false,
      isAmend: false,
      currentIndex: 0, // 控制哪个步骤处于激活状态
      steps: [
        {text: '选择部门', compents: 'stepOne'},
        {text: '选择事项', compents: 'stepTwo'},
        {text: '预约时间', compents: 'stepThree'},
        {text: '预约信息', compents: 'stepFour'}
      ],
      result: true,//是否显示步骤
      selectedStepType: 'inquire'
    }
  },
  methods: {
    amend() {
      let data = {
        busiId: this.$store.state.busi.busiId,
        ruleId: this.$store.state.rule.ruleId
      }
      amendOrder(data).then(res => {
        if (res.data.info) {
          if (res.data.info.status === 1) {
            this.$message.success(res.data.message)
            this.$store.commit("setBusi", res.data.info)
            this.result = false
            this.selectedStepType = 'resultView'
          } else {
            this.$message.warning(res.data.info.msg)
          }
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    submit() {
      let data = {
        ruleId: this.$store.state.rule.ruleId,
        projectId: this.$store.state.project.projectId,
        userName: this.$store.state.user.userName,
        userPhone: this.$store.state.user.userPhone,
        userCardNo: this.$store.state.user.userCardNo,
        cardType: 10,
        dataFrom: $grsc.dataFrom
      }
      submitRPriorBusi(data).then(res => {
        if (res.data.info) {
          if (res.data.info.status === 1) {
            this.$message.success(res.data.message)
            this.$store.commit("setBusi", res.data.info)
            this.result = false
            this.selectedStepType = 'resultView'
          } else {
            this.$message.warning(res.data.info.msg)
          }
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    // 计算属性用于获取当前组件名称
    currentComponent() {
      this.selectedStepType = this.steps[this.currentIndex].compents;
    },
    next() {
      if (this.currentIndex < this.steps.length - 1) { // 判断是否已经到达最后一个步骤
        this.currentIndex++; // 将当前步骤索引加1
        this.currentComponent()
      }
    },
    back() {
      if (this.currentIndex > 0) { // 判断是否已经到达第一个步骤
        this.currentIndex--; // 将当前步骤索引减1
        this.currentComponent()
      }
    },
    inputRadio(e) {
      if (e === 'inquire') {
        this.selectedStepType = 'inquire'
        this.result = false
      } else {
        this.currentIndex = 0
        this.currentComponent()
        this.result = true
      }
    },
    againOrder() {
      this.result = true
      this.isAmend = false
      this.tabPosition = 'top'
      this.currentIndex = 2
      this.currentComponent()
    },
    amendOrder() {
      this.result = true
      this.isAmend = true
      this.tabPosition = 'top'
      this.currentIndex = 2
      this.currentComponent()
    },
    backDashboard() {
      this.result = true
      this.isAmend = false
      this.tabPosition = 'top'
      this.currentIndex = 0
      this.currentComponent()
    }
  }
}
</script>

<style lang="less" scoped>

.home {
  height: 100%;
  background: url("../assets/bg.png") no-repeat;
  background-size: 100% 100%;
  overflow: auto;

  .container {
    width: 1200px;
    margin: 0 auto;

    .title {
      font-size: 32px;
      font-weight: 600;
      padding-top: 80px;
    }

    ::v-deep .radio-tab {
      display: flex;
      justify-content: center;
      margin: 20px 0;

      .el-radio-button__inner {
        padding: 15px 50px;
      }

      .el-radio-button:first-child .el-radio-button__inner {
        border-radius: 0;
      }

      .el-radio-button:last-child .el-radio-button__inner {
        border-radius: 0;
      }

      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background: linear-gradient(to right, #5CA5FF, #427AF4);
        color: #fff;
      }
    }

    .step-progress {
      display: flex;
      align-items: center;
    }

    .step {
      position: relative;
      flex: 1;
      text-align: center;
      color: #666;
      font-size: 14px;
      cursor: pointer;
    }

    .step-number {
      display: inline-block;
      width: 40px;
      height: 40px;
      line-height: 40px;
      margin-right: 10px;
      border-radius: 50%;
      background-color: #EAEBEE;
      font-weight: bold;

    }

    .step.active .step-number,
    .step.active .step-text {
      color: #2196F3;
    }

    .step.active .step-number {
      background: #dbe4fb;

      span {
        display: inline-block;
        width: 30px;
        height: 30px;
        line-height: 30px;
        border-radius: 50%;
        background-color: #427AF4;
        font-weight: bold;
        color: #fff;
      }
    }

    .step:first-child::before {
      display: none; /* 隐藏第一个步骤前的线 */
    }

    .step:last-child::after {
      display: none; /* 确保最后一个步骤后没有线 */
    }

    .step::after {
      content: '';
      position: absolute;
      top: 50%;
      right: -20%;
      transform: translateY(-50%);
      width: 50%;
      height: 1px;
      background-color: #ccc;
    }

    .stepsContent {
      margin-top: 20px;
    }

    .btn {
      text-align: center;
      padding: 20px;

      .btn-left {
        color: #427AF4;
      }

      .btn-right {
        background: #427AF4;
      }
    }
  }
}
</style>
